import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var EnquiryListRes;
export const EnquiryListTodo = createAsyncThunk('EnquiryList', async (data) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "Post",
            url: process.env.REACT_APP_API_URL + 'admin_get_subscription',
            params:{
                "user_id": localStorage.getItem('user_id')
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return EnquiryListRes = res.data

    } catch (error) {
        return EnquiryListRes = error.response.data
    }
})

const EnquiryListSlice = createSlice({
    name: 'EnquiryList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(EnquiryListTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('equipmentList', state.data.response)
        });
        builder.addCase(EnquiryListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default EnquiryListSlice.reducer; 